const Testimonial_dataSlider = [
    {
      id: 1,
      name: "Madan Raj Rajagopal",
      title: "Founder & CEO, Ludimos",
      img:"/assets/maddy.png",
   
      desc:        
      "Vaishali was involved in designing a couple of interfaces at Ludimos. Being a cricket coach and a UX expert, she was able to quickly understand the requirements I had and came up with very well thought user journeys. She was extremely proactive and she dived into several other aspects of the design, which weren't even a part of my requirement. She was motivated, energetic and lovely to work with. I wish her all the very best for her future endeavors.",
     
   },
    {
      id: 2,
      name: "Suzanne Lambert",
      title: "Chair & Trustee, DODI Charity",
      img: "https://i0.wp.com/dodi.org.uk/wp-content/uploads/2021/07/5.-Suzanne-Lambert-1.jpg?resize=768%2C576&ssl=1",
     
      desc:
        "Vaishali worked hard to understand exactly what we were looking for, giving us options and ideas and we are delighted with the results. The impact on the charity's profile has been amazing, both in audience reach and funds raised.  Website visits have been increased by over 80%, the email campaign audience by 70% and our online donations have trebled. Payment systems have been transformed through ease of use and general accessibility.",
        featured: true,
    },
    {
      id: 3,
      name: "Peter Mitchell",
      title: "Clinical Manager, NHS Homerton Hospital",
      img:
        "https://www.eyenews.uk.com/media/5718/peter-mitchell.jpg?anchor=center&mode=crop&width=190&height=200&rnd=133002939440000000",
   
      desc:
        "I have worked with Vaishali in the senior clinical team at Homerton University Hospital for over 15 years and in that time have come to respect her attention to detail that underpins all her work. Accurate and effective communication is one of her key drivers.  She has the ability to make existing content simple and clear to understand. With the user/patient as the focus of all we do and a strong team spirit to deliver an excellent service.",
        
    },
  ];

  export default Testimonial_dataSlider;

  // She is also a great team-player and in brainstorm sessions, discussing how to improve our training, she has always been a creative and innovative contributor